import styled, { css } from 'styled-components';

export const Container = styled.div<{ $sticky?: boolean }>`
	display: flex;
	flex-wrap: wrap;
	gap: 8px;
	margin-bottom: 20px;
	align-items: center;

	${({ $sticky, theme }) =>
		$sticky &&
		css`
			position: sticky;
			top: 0;
			z-index: 5;
			background-color: ${theme.gray[0]};
			padding: 8px 62px;
			margin: 0 -62px 12px;
			border-bottom: 1px solid ${theme.gray[200]};
		`}
`;

export const Pill = styled.button<{ $selected?: boolean; $scrollActive?: boolean }>`
	padding: 6px 12px;
	border-radius: 16px;
	border: 1px solid
		${({ theme, $selected }) => ($selected ? theme.blue[500] : theme.gray[200])};
	background-color: ${({ theme, $selected }) =>
		$selected ? theme.gray[1000] : theme.gray[0]};
	color: ${({ theme, $selected }) => ($selected ? theme.gray[0] : theme.gray[800])};
	font-size: 13px;
	font-weight: ${({ $selected }) => ($selected ? 500 : 400)};
	transition: all 0.2s ease;
	display: flex;
	align-items: center;
	gap: 4px;
	position: relative;

	// Scroll-spy indicator: subtle underline when this section is in view
	${({ $scrollActive, theme }) =>
		$scrollActive &&
		css`
			border-color: ${theme.gray[600]};
			color: ${theme.gray[1000]};
			font-weight: 500;
		`}

	&:hover {
		border-color: ${({ theme, $selected }) =>
			$selected ? theme.blue[600] : theme.gray[200]};
		background-color: ${({ theme, $selected }) =>
			$selected ? theme.gray[1000] : theme.gray[100]};
	}

	&:focus-visible {
		outline: 2px solid ${({ theme }) => theme.blue[500]};
		outline-offset: 2px;
	}
`;

export const Count = styled.span`
	font-size: 11px;
	opacity: 0.7;
`;

export const ClearButton = styled.button`
	padding: 6px 0;
	border: none;
	background: none;
	color: ${({ theme }) => theme.gray[600]};
	font-size: 13px;
	font-weight: 400;
	transition: color 0.2s ease;
	white-space: nowrap;
	margin-left: 4px;

	&:hover {
		color: ${({ theme }) => theme.gray[900]};
	}

	&:focus-visible {
		outline: 2px solid ${({ theme }) => theme.blue[500]};
		outline-offset: 2px;
		border-radius: 4px;
	}
`;
